export const GET_SERVING_MENU_ITEMS = 'GET_SERVING_MENU_ITEMS';
export const GET_SERVING_SUBMENU_ITEMS = 'GET_SERVING_SUBMENU_ITEMS';
export const SELECTED_SERVING_MENU = 'SELECTED_SERVING_MENU';
export const SELECTED_SERVING_SUB_MENU = 'SELECTED_SERVING_SUB_MENU';
export const SET_DELAY = 'SET_DELAY';
export const SET_SELECTED_FOOD_ITEM = 'SET_SELECTED_FOOD_ITEM';
export const SET_SELECTED_SUB_MENU = 'SET_SELECTED_SUB_MENU';
export const SET_STARTING_CASH = 'SET_STARTING_CASH';
export const RESTORE_STARTING_CASH_FROM_USER_SETTINGS =
  'RESTORE_STARTING_CASH_FROM_USER_SETTINGS';
export const GET_QUICK_SERVE_ITEMS_DROPDOWN = 'GET_QUICK_SERVE_ITEMS_DROPDOWN';
export const SET_DROPDOWN_SELECTED_VALUE = 'SET_DROPDOWN_SELECTED_VALUE';
export const SET_START_SERVING_ENABLED = 'SET_START_SERVING_ENABLED';
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
export const ON_SESSION_CREATED = 'ON_SESSION_CREATED';
export const CLEAR_CURRENT_SESSION = 'CLEAR_CURRENT_SESSION';
export const ON_SESSION_ADD = 'ON_SESSION_ADD';
export const SET_ACTIVE_SESSION = 'SET_ACTIVE_SESSION';
export const CHANGE_QUICK_SERVE_ITEM = 'CHANGE_QUICK_SERVE_ITEM';
export const SET_ACTIVE_SESSION_INTERVAL = 'SET_ACTIVE_SESSION_INTERVAL';
export const SET_AUTOSERVE_ON_OFF = 'SET_AUTOSERVE_ON_OFF';
export const GET_CEP_TYPES = 'GET_CEP_TYPES';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptions/state/types.js